// first: no eval in the browser (before any schema is made)
import '@london-life/api-client/no-eval';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { applyDesignTokens } from '@london-life/ui/design';
import '@london-life/ui/styles.css';
import { ErrorBoundary } from '@london-life/ui/feedback/error-boundary';
import { App } from './app';
import { watchKeyboard } from './lib/keyboard';

// start the player app with the shared design colours on the root element
applyDesignTokens(document.documentElement);
watchKeyboard();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
